(function(){
const $=s=>document.querySelector(s),$$=s=>[...document.querySelectorAll(s)];
const money=c=>'$'+(c/100).toFixed(2);
let tt;function toast(s){const t=$('#toast');if(!t)return;t.textContent=s;t.classList.add('on');clearTimeout(tt);tt=setTimeout(()=>t.classList.remove('on'),1800);}

/* clock */
const ck=$('#clock');if(ck){const tick=()=>{ck.textContent='Portland '+new Date().toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',timeZone:'America/Los_Angeles'});};tick();setInterval(tick,15000);}

/* mobile nav */
const mn=$('#mnav');if(mn){$('#mb').onclick=()=>mn.classList.add('open');$('#mx').onclick=()=>mn.classList.remove('open');}

/* cart drawer (Shopify Ajax API) */
const dr=$('#dr'),scrim=$('#scrim');
const openCart=()=>{dr.classList.add('on');scrim.classList.add('on');},closeCart=()=>{dr.classList.remove('on');scrim.classList.remove('on');};
if(dr){
  $('#dc').onclick=closeCart;scrim.onclick=closeCart;
  const cb=$('#cartBtn');if(cb)cb.onclick=e=>{e.preventDefault();refresh().then(openCart);};
  $('#items').addEventListener('click',e=>{
    const q=e.target.closest('[data-q]'),r=e.target.closest('[data-rm]');
    if(q)change(+q.dataset.line,+q.dataset.qty);
    if(r)change(+r.dataset.line,0);
  });
}
function render(c){
  const cc=$('#cc');if(cc)cc.textContent=c.item_count;
  if(!dr)return;
  if(!c.items.length){$('#items').innerHTML='<div class="em">Your bag is empty.</div>';}
  else $('#items').innerHTML=c.items.map((i,x)=>`<div class="row"><img src="${i.image?i.image.replace(/(\.[a-z]+)(\?.*)?$/,'_300x$1'):''}" alt=""><div><span class="serif">${i.product_title}</span><div class="v">${i.variant_title||''}</div><div class="q"><button data-q data-line="${x+1}" data-qty="${i.quantity-1}">–</button><span>${i.quantity}</span><button data-q data-line="${x+1}" data-qty="${i.quantity+1}">+</button></div><button class="rm" data-rm data-line="${x+1}">Remove</button></div><div>${money(i.final_line_price)}</div></div>`).join('');
  $('#sub').textContent=money(c.items_subtotal_price);
}
const refresh=()=>fetch('/cart.js').then(r=>r.json()).then(c=>{render(c);return c;});
const change=(line,quantity)=>fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line,quantity})}).then(r=>r.json()).then(render);
if(dr)refresh();

/* product page: variant picker + ajax add */
const pf=$('#pform');
if(pf){
  const variants=JSON.parse($('#variants').textContent);
  const sel=[...$$('.sizes')].map(g=>(g.querySelector('.on')||{}).dataset?.v||null);
  // single-value options are fixed
  const p=$('#pdp');
  const fixed=variants[0]?[variants[0].option1,variants[0].option2,variants[0].option3]:[];
  function current(){
    const opts=[];let gi=0;
    // map each option index to either fixed value or selection
    const groups=$$('.sizes');
    const nOpts=variants[0].options.length;
    for(let i=0;i<nOpts;i++){const g=groups.find(x=>+x.dataset.opt===i);opts.push(g?(g.querySelector('.on')||{}).dataset?.v:fixed[i]);}
    return variants.find(v=>v.options.every((o,i)=>opts[i]===undefined||o===opts[i]));
  }
  function sync(){
    const v=current();const btn=$('#addBtn');
    if(!v){btn.disabled=true;btn.textContent='Unavailable';return;}
    $('#vid').value=v.id;$('#price').firstChild.textContent=money(v.price)+' ';
    btn.disabled=!v.available;btn.textContent=v.available?(btn.dataset.t||btn.textContent.replace('Sold out',btn.dataset.t||'Add to bag')):'Sold out';
  }
  $('#addBtn').dataset.t=$('#addBtn').textContent.trim();
  $$('.sizes').forEach(g=>g.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;[...g.children].forEach(x=>x.classList.toggle('on',x===b));sync();}));
  pf.addEventListener('submit',e=>{
    e.preventDefault();
    const needs=$$('.sizes').some(g=>!g.querySelector('.on'));
    if(needs){toast('Choose a size');return;}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+$('#vid').value,quantity:1}]})})
      .then(r=>r.ok?r.json():r.json().then(j=>Promise.reject(j)))
      .then(()=>refresh().then(()=>{openCart();toast('Added to bag');}))
      .catch(j=>toast(j.description||'Could not add'));
  });
  if($$('.sizes').every(g=>g.querySelector('.on')))sync();
}

/* collection filters (by product type or tag) */
const fil=$('#fil');
if(fil){
  const cards=$$('#shop .card');
  function apply(f){
    let n=0;cards.forEach(c=>{const ok=f==='all'||c.dataset.type===f||(' '+c.dataset.tags+' ').includes(' '+f+' ');c.style.display=ok?'':'none';if(ok)n++;});
    $$('#fil button').forEach(b=>b.classList.toggle('on',b.dataset.f===f));
    $('#cnt').textContent=n+(n===1?' piece':' pieces');
    if(window.gsap)gsap.fromTo('#shop .card:not([style*="none"])',{opacity:0,y:16},{opacity:1,y:0,duration:.6,stagger:.05,ease:'power2.out',overwrite:true});
  }
  fil.onclick=e=>{const b=e.target.closest('button');if(b){apply(b.dataset.f);history.replaceState(null,'',b.dataset.f==='all'?location.pathname:'?f='+b.dataset.f);}};
  const q=new URLSearchParams(location.search).get('f');if(q)apply(q);
}

/* motion */
function motion(){
  if(!window.gsap||!window.ScrollTrigger){$$('.rv').forEach(e=>e.style.opacity=1);return;}
  gsap.registerPlugin(ScrollTrigger);
  if(matchMedia('(prefers-reduced-motion:reduce)').matches){$$('.rv').forEach(e=>e.style.opacity=1);return;}
  const hero=$('.hero');
  if(hero){
    gsap.set('.hero .rv',{opacity:0,y:18});
    gsap.timeline({defaults:{ease:'power3.out'}}).to('.hero .eyebrow',{opacity:1,y:0,duration:.8},.1).to('.hero h1',{opacity:1,y:0,duration:.9},'-=.5').to('.hero .sub',{opacity:1,y:0,duration:.8},'-=.6');
    const hi=$('.hero .ph img');if(hi)gsap.fromTo(hi,{scale:1.08},{scale:1,duration:1.6,ease:'power2.out'});
  }
  $$('.rv').forEach(el=>{if(el.closest('.hero'))return;gsap.fromTo(el,{opacity:0,y:18},{opacity:1,y:0,duration:.9,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 88%',once:true}});});
  $$('[data-parallax]').forEach(img=>gsap.fromTo(img,{yPercent:-6},{yPercent:6,ease:'none',scrollTrigger:{trigger:img.parentElement,scrub:true,start:'top bottom',end:'bottom top'}}));
  if($('#shop')&&window.gsap)gsap.fromTo('#shop .card',{opacity:0,y:16},{opacity:1,y:0,duration:.6,stagger:.04,ease:'power2.out'});
}
window.addEventListener('load',motion);
})();
